import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { applyTenantFromHost, ensureDeviceFingerprint } from "./lib/api";
import { CF_DEPLOY_STAMP } from "./deploy-stamp";
import "./styles.css";

applyTenantFromHost();
ensureDeviceFingerprint();
console.info(`[dataroom] build ${CF_DEPLOY_STAMP}`);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
